import { useState } from "react";
import { SectionCard } from "../../../components/SectionCard";
import { Button } from "../../../components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../components/ui/alert-dialog";
import { toast } from "sonner";
import { useLanguage } from "../../../contexts/LanguageContext";
import { settingsLabels } from "../labels";

export function DeleteAccountSection() {
  const { lang } = useLanguage();
  const t = settingsLabels[lang].deleteAccount;
  const [open, setOpen] = useState(false);

  const onConfirm = () => {
    setOpen(false);
    toast.success(t.toast);
  };

  return (
    <>
      <SectionCard
        header={<div className="font-semibold text-red-700">{t.header}</div>}
        action={
          <Button className="bg-red-600 text-white hover:bg-red-700" onClick={() => setOpen(true)}>
            {t.action}
          </Button>
        }
      >
        <div className="space-y-2">
          <p className="text-sm text-neutral-700">{t.desc1}</p>
          <p className="text-sm text-neutral-700 font-medium">{t.desc2}</p>
        </div>
      </SectionCard>

      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="rounded-3xl border-0 shadow-2xl">
          <AlertDialogHeader className="text-left flex flex-col gap-2">
            <AlertDialogTitle className="text-xl font-bold text-neutral-800 tracking-tight">{t.dialog.title}</AlertDialogTitle>
            <AlertDialogDescription className="text-sm text-neutral-500 font-medium">
              {t.dialog.description}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="pt-4 gap-3">
            <AlertDialogCancel className="h-11 rounded-xl font-bold border-neutral-200">{t.dialog.cancel}</AlertDialogCancel>
            <AlertDialogAction 
              className="h-11 rounded-xl font-bold bg-red-600 hover:bg-red-700 text-white border-none" 
              onClick={onConfirm}
            >
              {t.dialog.confirm}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
